import { z } from 'zod';
import { validateState } from './ValidateState.ts';
export var CardEnum = /*#__PURE__*/ function(CardEnum) {
    CardEnum[CardEnum["ResourceBack"] = 0] = "ResourceBack";
    CardEnum[CardEnum["Lumber"] = 1] = "Lumber";
    CardEnum[CardEnum["Brick"] = 2] = "Brick";
    CardEnum[CardEnum["Wool"] = 3] = "Wool";
    CardEnum[CardEnum["Grain"] = 4] = "Grain";
    CardEnum[CardEnum["Ore"] = 5] = "Ore";
    CardEnum[CardEnum["Cloth"] = 6] = "Cloth";
    CardEnum[CardEnum["Coin"] = 7] = "Coin";
    CardEnum[CardEnum["Paper"] = 8] = "Paper";
    CardEnum[CardEnum["AnyResource"] = 9] = "AnyResource";
    CardEnum[CardEnum["DevelopmentBack"] = 10] = "DevelopmentBack";
    CardEnum[CardEnum["Knight"] = 11] = "Knight";
    CardEnum[CardEnum["VictoryPoint"] = 12] = "VictoryPoint";
    CardEnum[CardEnum["Monopoly"] = 13] = "Monopoly";
    CardEnum[CardEnum["RoadBuilding"] = 14] = "RoadBuilding";
    CardEnum[CardEnum["YearOfPlenty"] = 15] = "YearOfPlenty";
    CardEnum[CardEnum["CommodityBack"] = 16] = "CommodityBack";
    CardEnum[CardEnum["ProgressCardTradeBack"] = 17] = "ProgressCardTradeBack";
    CardEnum[CardEnum["ProgressCardTradeCommercialHarbor"] = 18] = "ProgressCardTradeCommercialHarbor";
    CardEnum[CardEnum["ProgressCardTradeMasterMerchant"] = 19] = "ProgressCardTradeMasterMerchant";
    CardEnum[CardEnum["ProgressCardTradeMerchant"] = 20] = "ProgressCardTradeMerchant";
    CardEnum[CardEnum["ProgressCardTradeMerchantFleet"] = 21] = "ProgressCardTradeMerchantFleet";
    CardEnum[CardEnum["ProgressCardTradeResourceMonopoly"] = 22] = "ProgressCardTradeResourceMonopoly";
    CardEnum[CardEnum["ProgressCardTradeCommodityMonopoly"] = 23] = "ProgressCardTradeCommodityMonopoly";
    CardEnum[CardEnum["ProgressCardPoliticsBack"] = 24] = "ProgressCardPoliticsBack";
    CardEnum[CardEnum["ProgressCardPoliticsBishop"] = 25] = "ProgressCardPoliticsBishop";
    CardEnum[CardEnum["ProgressCardPoliticsConstitution"] = 26] = "ProgressCardPoliticsConstitution";
    CardEnum[CardEnum["ProgressCardPoliticsDeserter"] = 27] = "ProgressCardPoliticsDeserter";
    CardEnum[CardEnum["ProgressCardPoliticsDiplomat"] = 28] = "ProgressCardPoliticsDiplomat";
    CardEnum[CardEnum["ProgressCardPoliticsIntrigue"] = 29] = "ProgressCardPoliticsIntrigue";
    CardEnum[CardEnum["ProgressCardPoliticsSaboteur"] = 30] = "ProgressCardPoliticsSaboteur";
    CardEnum[CardEnum["ProgressCardPoliticsSpy"] = 31] = "ProgressCardPoliticsSpy";
    CardEnum[CardEnum["ProgressCardPoliticsWarlord"] = 32] = "ProgressCardPoliticsWarlord";
    CardEnum[CardEnum["ProgressCardPoliticsWedding"] = 33] = "ProgressCardPoliticsWedding";
    CardEnum[CardEnum["ProgressCardScienceBack"] = 34] = "ProgressCardScienceBack";
    CardEnum[CardEnum["ProgressCardScienceAlchemist"] = 35] = "ProgressCardScienceAlchemist";
    CardEnum[CardEnum["ProgressCardScienceCrane"] = 36] = "ProgressCardScienceCrane";
    CardEnum[CardEnum["ProgressCardScienceEngineer"] = 37] = "ProgressCardScienceEngineer";
    CardEnum[CardEnum["ProgressCardScienceInventor"] = 38] = "ProgressCardScienceInventor";
    CardEnum[CardEnum["ProgressCardScienceIrrigation"] = 39] = "ProgressCardScienceIrrigation";
    CardEnum[CardEnum["ProgressCardScienceMedicine"] = 40] = "ProgressCardScienceMedicine";
    CardEnum[CardEnum["ProgressCardScienceMining"] = 41] = "ProgressCardScienceMining";
    CardEnum[CardEnum["ProgressCardSciencePrinter"] = 42] = "ProgressCardSciencePrinter";
    CardEnum[CardEnum["ProgressCardScienceRoadBuilding"] = 43] = "ProgressCardScienceRoadBuilding";
    CardEnum[CardEnum["ProgressCardScienceSmith"] = 44] = "ProgressCardScienceSmith";
    CardEnum[CardEnum["ProgressCardBack"] = 45] = "ProgressCardBack";
    CardEnum[CardEnum["ResourceOverLimit"] = 46] = "ResourceOverLimit";
    return CardEnum;
}({});
export var CardTypeEnum = /*#__PURE__*/ function(CardTypeEnum) {
    CardTypeEnum[CardTypeEnum["Resource"] = 0] = "Resource";
    CardTypeEnum[CardTypeEnum["Commodity"] = 1] = "Commodity";
    CardTypeEnum[CardTypeEnum["AnyResource"] = 2] = "AnyResource";
    CardTypeEnum[CardTypeEnum["Development"] = 3] = "Development";
    CardTypeEnum[CardTypeEnum["ProgressTrade"] = 4] = "ProgressTrade";
    CardTypeEnum[CardTypeEnum["ProgressPolitics"] = 5] = "ProgressPolitics";
    CardTypeEnum[CardTypeEnum["ProgressScience"] = 6] = "ProgressScience";
    CardTypeEnum[CardTypeEnum["Miscellaneous"] = 7] = "Miscellaneous";
    return CardTypeEnum;
}({});
export var CardDistributionType = /*#__PURE__*/ function(CardDistributionType) {
    CardDistributionType[CardDistributionType["StartingResources"] = 0] = "StartingResources";
    CardDistributionType[CardDistributionType["ResourceTile"] = 1] = "ResourceTile";
    CardDistributionType[CardDistributionType["GoldTile"] = 2] = "GoldTile";
    CardDistributionType[CardDistributionType["Aqueduct"] = 3] = "Aqueduct";
    CardDistributionType[CardDistributionType["BarbarianProgressCard"] = 4] = "BarbarianProgressCard";
    return CardDistributionType;
}({});
export const cardStateOrderedSchema = z.object({
    cards: z.array(z.enum(CardEnum))
}).strict();
export function validateCardStateOrdered(data) {
    return validateState(cardStateOrderedSchema, data);
}
export const cardStateUnorderedSchema = z.partialRecord(z.enum(CardEnum), z.number().int().nonnegative());
export function validateCardStateUnordered(data) {
    return validateState(cardStateUnorderedSchema, data);
}
